<template>
    <v-container fill-height fluid>
        <v-row align="center" justify="center">
            <v-col class="text-center" cols="10" sm="6" md="3">
                <p>Anmeldung</p>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "verification"
    }
</script>

<style scoped>

</style>